/**
 * TermsPage — Términos de Servicio (Sprint 14 S14.2 — R1 GDPR).
 *
 * Ruta PÚBLICA /terms (accesible sin login). Contenido verbatim de
 * src/content/legal.ts. Incluye el aviso de salud prominente (sección 2).
 */
import { LegalDocument } from "@/components/legal/LegalDocument";
import { TERMS_MARKDOWN } from "@/content/legal";

export function TermsPage() {
  return <LegalDocument source={TERMS_MARKDOWN} testId="terms-page" />;
}
